import { Button } from '@mui/material';
import Excel from 'exceljs';
import FileSaver from 'file-saver';
import React from 'react';
import { SalesSummaryPageQuery } from '../../../../services';
import dayjs from 'dayjs';

export async function downloadSalesSummaryReport(
    sales?: SalesSummaryPageQuery['getProductSalesSummary']['sales'],
) {
    const workbook = new Excel.Workbook();
    const salesWs = workbook.addWorksheet();
    salesWs.addRow([
        'Cliente',
        // Three different documents each carry a folio, so every header names
        // its entity — a bare "Folio" would be ambiguous here.
        'Folio de pedido',
        'Folio de venta',
        'Folio de factura',
        'Año',
        'Mes',
        'Mes 2',
        'Día',
        'Producto',
        'Material',
        'Ancho',
        'Largo',
        'Calibre',
        'Kilos',
        'Total sin iva',
        'Total con iva',
    ]);
    sales?.forEach((sale) => {
        salesWs.addRow([
            sale.account_name,
            // null when the sale was created without an order request.
            sale.order_request_code ?? '',
            sale.order_code,
            // 0 is the "no invoice" default (nota de remisión), not a real folio.
            sale.invoice_code ? sale.invoice_code : '',
            sale.year,
            sale.month !== null && sale.month !== undefined
                ? dayjs().set('month', sale.month - 1).format('MMMM')
                : '',
            sale.month,
            sale.day,
            sale.product_name,
            sale.product_material_name,
            sale.width,
            sale.length,
            sale.calibre,
            sale.kilos_sold,
            sale.total,
            sale.total_with_tax,
        ]);
    });

    salesWs.columns.forEach((column, index) => {
        let maxColumnLength = 6;
        if (column.eachCell) {
            column.eachCell({ includeEmpty: true }, (cell) => {
                maxColumnLength = Math.max(
                    maxColumnLength,
                    cell.value ? cell.value.toString().length : 0,
                );
            });
        }
        salesWs.getColumn(index + 1).width = maxColumnLength;
    });
    salesWs.getColumn(11).alignment = { horizontal: 'right' };

    const buffer = await workbook.xlsx.writeBuffer();
    FileSaver.saveAs(new Blob([buffer]), 'ventas-por-producto.xlsx');
}

export function SalesSummaryExcelExportButton({
    sales,
    disabled,
}: {
    sales?: SalesSummaryPageQuery['getProductSalesSummary']['sales'];
    disabled: boolean;
}) {
    return (
        <Button
            variant={'outlined'}
            size={'small'}
            disabled={disabled}
            onClick={() => void downloadSalesSummaryReport(sales)}
        >
            Descargar reporte
        </Button>
    );
}
